import React, { useEffect, useState } from 'react';
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from '../../elements';
import { Grid, MenuItem, Paper } from '@mui/material';
import DashBoard from '../components/DashBoard';
import { trackActivity } from '../../../utils/mixpanel';
import { useDispatch, useSelector } from 'react-redux';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { PopOverCTA } from '../../../shared_elements';
import { getCurrencyAc } from '../../../shared_elements/actionCreators';
import '../styles/InvoiceStats.scss';
import '../styles/statistic.scss';

const Statistics = () => {
	const dispatch = useDispatch();
	const { leaseBasicDetails, currencies } = useSelector((state) => state.leases);
	const [currency, setCurrency] = useState('USD');
	const currencyOptions = currencies?.length > 0 ? currencies : [{ id: 27, code: 'GBP' }, { id: 3, code: 'EURO' }, { id: 1, code: 'USD' }];
	const currencyLabel = currency || 'USD';

	useEffect(() => {
		trackActivity('Page Viewed', { page_title: 'Statistics' })
	}, [])

	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: 'Statistics', page_type: page_type })
	}

	useEffect(() => {
		if (!currencies?.length) {
			dispatch(getCurrencyAc({}));
		}
	}, [currencies?.length, dispatch]);

	return (
		<>
			<LeasesBasicDetails />
			<Paper className='lease-details-section lease-details-height lease-module-paper' elevation={0}>
				<LeasesNav />
				{leaseBasicDetails?.status === 'Draft' ? (<ModuleNotExcessModal moduleName="Statistics" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
				<div className='lease-details-content lease-content-overflow statistics-content-flex statistics-page-content' style={{margin: "2px 0px 0px 190px"}}>
					<Paper square className="responsive-paper statistics-filter-row">
						<Grid container spacing={0.5} className="responsive-grid" alignItems='flex-end'>
							<Grid item md={6} xs={6} className="menu-container" mt='6px'>
								<BackToLeaseList/>
							</Grid>
							<Grid item md={6} xs={6} className="statistics-currency-col">
								<ul className="list-inline lease-details-right-items lease-details-btn statistics-currency-list" style={{padding: "0px"}}>
									<li className="list-inline-item lease-mobile-button">
										<PopOverCTA btnText={currencyLabel} onCloseItem={true} menuMaxHeight={300}>
											<>
												{currencyOptions.map((cur) => (
													<MenuItem key={cur.id} onClick={() => { setCurrency(cur.code); handleItemClicked(`Currency Selected: ${cur.code}`) }}>
														{cur.code}
													</MenuItem>
												))}
											</>
										</PopOverCTA>
									</li>
								</ul>
							</Grid>
						</Grid>
					</Paper>
					<Paper className='lease-detail-table statistics-scroll-paper lease-module-paper' elevation={0} square>
						<div className="statistics-scroll-area">
							<DashBoard currency={currency} />
						</div>
					</Paper>
				</div>}
			</Paper>
		</>
	)
}

export default Statistics;